/**
 * Taksasi API Configuration
 * 
 * Centralized endpoint constants for Taksasi API
 */

export const TAKSASI_API_CONFIG = {
  BASE_PATH: '/api/pijar/taksasi',
  
  endpoints: {
    LIST: '/api/pijar/taksasi',
    DETAIL: (id: string) => `/api/pijar/taksasi/${id}`,
  },
} as const;

/**
 * Default pagination settings
 */
export const TAKSASI_DEFAULTS = {
  PAGE: 1,
  LIMIT: 100,
  MAX_LIMIT: 100,
} as const;

/**
 * Date format constants
 */
export const DATE_FORMATS = {
  API: 'YYYY-MM-DD',
  DISPLAY: 'DD/MM/YYYY',
  DISPLAY_WITH_TIME: 'DD/MM/YYYY HH:mm',
} as const;
